import { IAddress } from '@jumpstart/core';
import { getDatabase, ref, update } from 'firebase/database';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { FirebaseHandlers } from '../../../../core/firebase';

const functions = getFunctions();
const customerCreateFn: any = httpsCallable(functions, 'stripe-customer-create');
const attachMethodFn: any = httpsCallable(functions, 'stripe-customer-payment-methods-attach');


export interface IAttachMethodInput {
  production: boolean;

  /**
   * scout9-profiles/{uid} - we don't want to pass Stripe customer ids around in case we mess up our integration
   */
  profileId: string;

  existingPaymentMethod?: string;
  newPaymentMethod?: {
    type: | 'acss_debit'
      | 'afterpay_clearpay'
      | 'alipay'
      | 'au_becs_debit'
      | 'bacs_debit'
      | 'bancontact'
      | 'boleto'
      | 'card'
      | 'eps'
      | 'fpx'
      | 'giropay'
      | 'grabpay'
      | 'ideal'
      | 'klarna'
      | 'oxxo'
      | 'p24'
      | 'sepa_debit'
      | 'sofort'
      | 'wechat_pay';
    card: {
      number: string;
      exp_month: number;
      exp_year: number;
      cvc?: string
    }
  }
}

export interface ICreateCustomer {
  profileId: string;
  name?: string;
  phone?: string;
  email?: string;
  address?: IAddress;
  production: boolean;
}

export const createStripeCustomer = async (input: Omit<ICreateCustomer, 'production'>): Promise<{customer: any; status: string}> => {
  const db = getDatabase();
  const updates: any = {};
  if (input.address) {
    updates.address = input.address;
  }
  if (Object.keys(input).length > 0) {
    await update(ref(db, `scout9-profiles/${input.profileId}`), updates)
      .then(() => {
        console.log('Profile Updated');
      })
      .catch((err: Error) => {
        console.error('Failed to update user', err.message);
      });
  }
  // return FirebaseHandlers.run<ICreateCustomer, {customer: any; status: string}>({...input, production: process.env.NODE_ENV === 'production'}, customerCreateFn);
  console.warn('@TODO remove production override');
  return FirebaseHandlers.run<ICreateCustomer, {customer: any; status: string}>({...input, production: false}, customerCreateFn);
}

export const attachPaymentMethod = async (input: Omit<IAttachMethodInput, 'production'>): Promise<void> => {
  console.warn('@TODO remove production override');
  await FirebaseHandlers.run<IAttachMethodInput, void>({...input, production: false}, attachMethodFn);
  // await FirebaseHandlers.run<IAttachMethodInput, void>({...input, production: process.env.NODE_ENV === 'production'}, attachMethodFn);
}

